// src/screens/sales/executor/Executor.tsx

import React from 'react'
import classes from './Executor.module.sass'
import { Helmet } from 'react-helmet-async'
import { List } from './components/list/List'
import { Button } from '../../../common/components/button/Button'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import { useSelector } from 'react-redux'
import { selectCurrentCluster } from '../../../store/slices/currentClusterSlice'
import Search from '../../../common/components/listControl/search/Search'
import { useExecutor } from './hooks/useExecutor'
import { QrScanner } from '../../../common/components/qr/qrScanner/QrScanner'

export const Executor = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    edit,
    startEdit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    searchQuery,
    handleSearch,
    clearSearch,
    startDuplicate,
    qrModalActive,
    setQrModalActive,
    handleAttachUser,
    handleQrScan,
    togglePublishMotivation,
    toggleActive,
    togglePublish,
  } = useExecutor()

  return (
    <div className={classes.container}>
      <Helmet>
        <title>Исполнители</title>
        <meta
          name="description"
          content="Управление исполнителями (продавцы, официанты, курьеры)"
        />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>Исполнители</div>
        <Button onClick={startCreate} text="Создать" />
      </div>

      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по имени, телефону или должности"
        />
      </div>

      <List
        startEdit={startEdit}
        list={list}
        showDetails={showDetails}
        loading={loading}
        startDuplicate={startDuplicate}
        onAttachUser={handleAttachUser}
        onToggleActive={toggleActive}
        onTogglePublish={togglePublish}
        onTogglePublishMotivation={togglePublishMotivation}
      />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
        />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>

      <Modal modalActive={qrModalActive} setModalActive={setQrModalActive}>
        <QrScanner onScan={handleQrScan} />
      </Modal>
    </div>
  )
}
